import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#009fe3] text-white pt-12 pb-6 mt-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo + Description */}
          <div className="md:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/assets/img/g2g-logo.png" alt="Logo" className="w-12 h-8" />
              <span className="text-xl font-bold text-white">Guideline2Germany</span>
            </div>
            <p className="text-sm leading-relaxed text-white/90 mb-6 md:mb-0">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-3">{t("footer.quickLinks")}</h4>
            <ul className="space-y-2 text-sm text-white/90">
              <li><Link to="/course/courses" className="hover:underline">{t("footer.courses")}</Link></li>
              <li><Link to="/pages/book-appointment" className="hover:underline">{t("footer.bookAppointment")}</Link></li>
              <li><Link to="/pages/about-us" className="hover:underline">{t("footer.aboutUs")}</Link></li>
              <li><Link to="/pages/contact-us" className="hover:underline">{t("footer.contactUs")}</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold text-lg mb-3">{t("footer.support")}</h4>
            <ul className="space-y-2 text-sm text-white/90">
              <li><Link to="/pages/check-eligibility" className="hover:underline">{t("footer.eligibilityCheck")}</Link></li>
              <li><Link to="/pages/faq" className="hover:underline">{t("footer.faq")}</Link></li>
              <li><Link to="/pages/blog" className="hover:underline">{t("footer.blog")}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-3">{t("footer.contact")}</h4>
            <ul className="text-sm space-y-2 text-white/90">
              <li>info@guideline2germany.com</li>
              <li>+880 186 755 5287</li>
              <li>
                <Link
                  to="https://facebook.com/Guideline2Germany"
                  className="underline hover:text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("footer.fbMessenger")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-4 border-t border-white/20 text-center text-sm text-white/80">
          {t("footer.copyright")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
